import createIcon from '../../createIcon';

/**
 * @component @name Factory
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTBWMjJIMlYxMEw5IDdWOUwxNCA3VjEwSDIyWk0xNy4yIDguNUwxOCAySDIxTDIxLjggOC41SDE3LjJaTTExIDE4SDEzVjE0SDExVjE4Wk03IDE4SDlWMTRIN1YxOFpNMTcgMTRIMTVWMThIMTdWMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Factory = createIcon('Factory', [
  [
    'path',
    {
      d: 'M22 10V22H2V10L9 7V9L14 7V10H22ZM17.2 8.5L18 2H21L21.8 8.5H17.2ZM11 18H13V14H11V18ZM7 18H9V14H7V18ZM17 14H15V18H17V14Z',
      key: '18fw2x',
    },
  ],
]);

export default Factory;
